<template>
    <v-data-table :headers="headers" :items="commodity_details">
        <template v-slot:[`item.剪辑`]="{ item }">
            <v-btn :disabled="!item['录制ID']" @click="handleEdit(item['录制ID'],item['讲解开始时间'])">
                剪辑
            </v-btn>
        </template>
    </v-data-table>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps({
    commodity_details: Array
})

const headers = [
    { title: '达人昵称', key: '达人昵称', sortable: true },
    { title: '直播开始时间', key: '直播开始时间', sortable: true },
    { title: '讲解开始时间', key: '讲解开始时间', sortable: true },
    { title: '商品信息', key: '商品信息' },
    { title: '成交件数', key: '成交件数', sortable: true },
    { title: '成交数/分', key: '每分钟成交件数', sortable: true },
    { title: '平均在线人数', key: '直播间讲解期间平均在线人数', sortable: true },
    { title: '讲解时长(分钟)', key: '讲解时长(分钟)', sortable: true },
    { title: '已录制', key: '已录制', sortable: true },
    { title: '剪辑', key: '剪辑', sortable: false }
];

// const headers = [
//     { text: '达人昵称', value: '达人昵称' },
//     { text: '直播开始时间', value: '直播开始时间' },
//     { text: '讲解开始时间', value: '讲解开始时间' },
//     { text: '商品信息', value: '商品信息' },
//     { text: '成交件数', value: '成交件数' },
//     { text: '直播间讲解期间平均在线人数', value: '直播间讲解期间平均在线人数' },
//     { text: '讲解时长(分钟)', value: '讲解时长(分钟)' },
//     { text: '已录制', value: '已录制' },
//     { text: '剪辑', value: '剪辑' },
//   ]
const router = useRouter();

const handleEdit = (transcription_id, explain_t) => {
    //跳到剪辑页面
    // 使用router.resolve获取目标路由的完整URL，并附加查询参数
    const baseHref = router.resolve('kol/para').href;
    const hrefWithParam = `${baseHref}?tid=${transcription_id}&jtime=${explain_t}`;

    // 创建一个新的<a>元素，设置href和target，然后模拟点击
    const link = document.createElement('a');
    link.href = hrefWithParam;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}



</script>

<style scoped>
.bold-and-centered {
    text-align: center;
    font-weight: bold;
}
</style>